import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Filter } from 'modules/employee_onboarding/hooks/useTasksFilter'

interface Props {
  filterBy?: Filter
  clearFilter: () => void
}

export interface StateInfo {
  title: string
  description: string
}

const EmptyTasks: React.FC<Props> = ({ filterBy, clearFilter }) => {
  const emptyStateInfo = (): StateInfo => {
    switch (filterBy) {
      case 'mandatory':
        return {
          title: i18n.t('employees.onboarding_task.empty_state.mandatory.title'),
          description: i18n.t('employees.onboarding_task.empty_state.mandatory.description'),
        }
      case 'optional':
        return {
          title: i18n.t('employees.onboarding_task.empty_state.optional.title'),
          description: i18n.t('employees.onboarding_task.empty_state.optional.description'),
        }
      case 'overdue':
        return {
          title: i18n.t('employees.onboarding_task.empty_state.overdue.title'),
          description: i18n.t('employees.onboarding_task.empty_state.overdue.description'),
        }
      default:
        return {
          title: i18n.t('employees.onboarding_task.empty_state.no_tasks_to_do.title'),
          description: i18n.t('employees.onboarding_task.empty_state.no_tasks_to_do.description'),
        }
    }
  }
  return (
    <Box alignItems="center" justifyContent="center" width="full" height="full">
      <Box flexDirection="column" gap="s12" maxWidth="s600" textAlign="center" alignItems="center">
        <Text.Header2>{emptyStateInfo().title}</Text.Header2>
        <Text.Normal>{emptyStateInfo().description}</Text.Normal>
        {!!filterBy && (
          <Button type="primary" onClick={() => clearFilter()}>
            {i18n.t('filters.clear_filter')}
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default EmptyTasks
